import axios from 'axios'
import moment from 'moment'

// const BASE_URL = window.location.hostname
export async function getCurrentTime() {
  let response = await axios.get( `/reservations/get_time.json` )
  // console.table( response.data )
  return response.data
}

export async function getHeartbeats() {
  let response = await axios.get( '/reservations/heartbeats.json' )
  return response
}

export function getUpdatedTimes( location, date ) {
  let formattedDate = moment( date ).format( 'MM-DD-YYYY' )
  return axios.get( `/reservations/date_change.json?location=${ location }&date=${ formattedDate }`, {
    // baseURL: ARIGATO5_BASE_URL
    // baseURL: BASE_URL
  } )
}

export function getSuggestedTimes( location, date, time, partySize, res_token ) {
  let formattedDate = moment( date ).format( 'MM-DD-YYYY' )
  let params = `location=${ location }&date=${ formattedDate }&time=${ time }&party_size=${ partySize }&res_token=${ res_token }`
  
  return axios.get( '/reservations/suggested_times.json?' + params, {
    // baseURL: ARIGATO5_BASE_URL
    // baseURL: BASE_URL
  } )
}

export function bookRes( resPacket ) {

  let csrf_token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

  return axios.post( '/reservations/book_res.json', JSON.stringify( resPacket ), {
    // baseURL: ARIGATO5_BASE_URL,
    // baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrf_token,
    }
  } )
}